<app-input
  [options]="options"
  (valueChange)="onSearchValueChange($event)">
</app-input>
